import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Premium from "./pages/Premium";
import Layout from "./pages/Layout";
import Enquiry from "./pages/Enquiry";
import PremiumListing from "./pages/PremiumListing";
import Orders from "./pages/Orders";
import { Coupons, Customer, Customers, Offers } from "./pages";
import Index from "./pages/Dashboard/Index";
import Commission from "./pages/Commission";
import DeleteNumber from "./pages/DeleteNumber";
import Cron from "./pages/Cron";
import Crontable from "./pages/CronTable";
import EditCoupon from "./pages/EditCoupon";
import Notification from "./pages/Notification";
import NumbersUpload from "./pages/NumberUpload";
import DynamicText from "./pages/DynamicText";
import DynamicTextEdit from "./pages/DynamicText/DynamicTextEdit";
import DynamicImageEdit from "./pages/DynamicImage";

function Routing() {
  return (
    <div>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Index />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customer/:id" element={<Customer />} />
          <Route path="order/:id" element={<Customer />} />
          <Route path="premiums" element={<Premium />} />
          <Route path="premiumlisting/:number" element={<PremiumListing />} />
          <Route path="notification/:n_id" element={<Notification />} />
          <Route path="orders" element={<Orders />} />
          <Route path="coupons" element={<Coupons />} />
          <Route path="commission" element={<Commission />} />
          <Route path="offers" element={<Offers />} />
          <Route path="numbers-file" element={<NumbersUpload />} />
          <Route path="delete-number" element={<DeleteNumber />} />
          <Route path="cron" element={<Cron />} />
          <Route path="crons" element={<Crontable />} />
          <Route path="edit-coupon/:coupon" element={<EditCoupon />} />
          <Route path="dynamic-areas" element={<DynamicText />} />
          <Route path="dynamic-add/:area" element={<DynamicTextEdit />} />
          <Route path="dynamic-edit/:area" element={<DynamicTextEdit />} />
          <Route path="dynamic-image" element={<DynamicImageEdit />} />
        </Route>
      </Routes>
    </div>
  );
}

export default Routing;
